import { DataLoadedStatus, PolicyAppState } from '../../types';
import { ModuleId, SectionId } from '@nirvana/shared/dtos/types/policies/common';
import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { PoliciesReduxActions } from '../../actions';

// SELECTORS
export const getIsAntimalwareSettingsExclusionsListsLoaded = (state: PolicyAppState): DataLoadedStatus =>
  state.modules[ModuleId.ANTIMALWARE]?.sections[SectionId.EXCLUSIONS].additionalInfo.exclusionsListsLoaded ??
  DataLoadedStatus.NOT_LOADED;
export const getIsAntimalwareSettingsVendorsExclusionsListsLoaded = (state: PolicyAppState): DataLoadedStatus =>
  state.modules[ModuleId.ANTIMALWARE]?.sections[SectionId.EXCLUSIONS].additionalInfo.vendorsExclusionsListsLoaded ??
  DataLoadedStatus.NOT_LOADED;

// ACTIONS
export const setExclusionsListsLoadedForAntimalwareSettings = createAction<DataLoadedStatus>(
  PoliciesReduxActions.SET_EXCLUSIONS_LISTS_LOADED_FOR_ANTIMALWARE_SETTINGS
);
export const setExclusionsListsLoadedForAntimalwareSettingsActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<DataLoadedStatus>
): void => {
  const module = state.modules[ModuleId.ANTIMALWARE];

  if (!module) {
    return;
  }

  module.sections[SectionId.EXCLUSIONS].additionalInfo.exclusionsListsLoaded = action.payload;
};

export const setVendorsExclusionsListsLoadedForAntimalwareSettings = createAction<DataLoadedStatus>(
  PoliciesReduxActions.SET_VENDORS_EXCLUSIONS_LISTS_LOADED_FOR_ANTIMALWARE_SETTINGS
);
export const setVendorsExclusionsListsLoadedForAntimalwareSettingsActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<DataLoadedStatus>
): void => {
  const module = state.modules[ModuleId.ANTIMALWARE];

  if (!module) {
    return;
  }

  module.sections[SectionId.EXCLUSIONS].additionalInfo.vendorsExclusionsListsLoaded = action.payload;
};
